import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, OnInit, Renderer2 } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { KlevuSearch } from '@df/module-klevu-search/klevu-interfaces';
import { KlevuTrackService } from '@df/module-klevu-search/klevu-track.service';
import { NgInject } from '@df/ng/ng-inject';
import { SearchService } from '@df/search/search.service';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { LocalKlevuSearchService } from '../../../module/klevu-search/klevu-search.service.decorator';
@Component({
    selector: 'search-banner',
    templateUrl: './search-banner.html',
    styleUrls: ['./search-banner.scss'],
    standalone: true,
    imports: [HrefComponent, ImageModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBannerComponent extends UiComponent implements OnInit, OnChanges {
    @Input()
    term?: string;
    @Input()
    position?: 'top' | 'bottom';
    @Input()
    context: 'preview' | 'searchPage';
    currentBanner?: KlevuSearch.IBanner;
    banners?: KlevuSearch.IBanner[];

    @NgInject(SearchService)
    searchService!: LocalKlevuSearchService;

    constructor(
        private klevuTrackService: KlevuTrackService,
        private renderer2: Renderer2,
        private elementRef: ElementRef
    ) {
        super();
    }
    override ngOnInit(): void {
        super.ngOnInit();
        this.searchService.loadKlevuBanners().then(() => {
            this.banners = this.searchService.getEligibleBanners();
            this.onTermChange();
        });
    }
    override ngOnChanges(changes: any): void {
        if (changes['term'] && this.banners?.length) {
            this.onTermChange();
        }
        super.ngOnChanges(changes);
    }
    private onTermChange(): void {
        const term = this.term?.toLowerCase();
        this.currentBanner =
            term &&
            this.banners?.find(
                banner =>
                    (!this.position || banner?.position === this.position) &&
                    ((this.context === 'preview' && banner.showOnQuickSearch) ||
                        (this.context === 'searchPage' && banner.showOnLandingPage)) &&
                    banner.showForTerms?.find(i => i.toLowerCase() === term)
            );
        this.currentBanner
            ? this.renderer2.addClass(this.elementRef.nativeElement, '_visible')
            : this.renderer2.removeClass(this.elementRef.nativeElement, '_visible');
        this.detectChanges();
    }
    get currentBannerImg(): string | undefined {
        // if (this.client.isM || this.client.isS) {
        //     const bannerImg = this.currentBanner?.bannerImg;
        //     const lastDotIndex = bannerImg?.lastIndexOf('.');
        //     return bannerImg ? bannerImg.slice(0, lastDotIndex) + '-sm' + bannerImg.slice(lastDotIndex) : undefined;
        // } else {
        return this.currentBanner?.bannerImg;
        // }
    }
    trackClick() {
        this.klevuTrackService.trackBanner(this.currentBanner, this.term);
    }
}
